import * as React from 'react';
import Project from 'src/entities/Project';
import { RootState } from 'src/reducers/RootReducer';
import { connect, Dispatch } from 'react-redux';
import InvestmentFunnelComponent,
{ InvestmentFunnelComponentProps } from './InvestmentFunnel.component';
import { openModal, OpenModal, closeModal, CloseModal } from 'src/actions/modal';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import Person from 'src/entities/Person';
import Investment from 'src/entities/Investment';
import {
  SetInvestmentDataAction,
  setInvestmentData
} from 'src/actions/investment/set-data/SetInvestmentData.actions';
import AcceptsCommitmentContainer from './AcceptsCommitmentInvestment.container';

interface StateProps {
  project?: Project;
  activeProfile?: Person;
  investment?: Investment;
}

interface DispatchProps {
  openModal(component: JSX.Element): OpenModal;
  closeModal(): CloseModal;
  setInvestmentData(investment: Investment): SetInvestmentDataAction;
}

interface Props extends StateProps, DispatchProps {
  modalRef?: Modal;
  reinvestment: boolean;
}

interface State {
  showWarning: boolean;
}

class InvestmentFunnelContainer extends React.Component<Props, State> {

  public state: State = {
    showWarning: false,
  };

  public render(): React.ReactNode {
    if (!(
      this.props.project &&
      this.props.activeProfile &&
      this.props.investment
    )) {
      return null;
    }

    return <InvestmentFunnelComponent {...this.getComponentProps()} />;
  }

  private next(): void {
    if (!this.props.investment) {
      return;
    }

    if (!this.props.reinvestment && !this.props.investment.termsAndConditions) {
      this.setState({ showWarning: true });
      return;
    }

    this.props.openModal(<AcceptsCommitmentContainer reinvestment={this.props.reinvestment}/>);
  }

  private previous(): void {
    this.props.closeModal();
  }

  private getComponentProps(): InvestmentFunnelComponentProps {
    if (!(
      this.props.project &&
      this.props.activeProfile &&
      this.props.investment
    )) {
      throw new Error('some props are not defined');
    }

    return {
      project: this.props.project,
      modalRef: this.props.modalRef,
      person: this.props.activeProfile,
      investment: this.props.investment,
      reinvestment: this.props.reinvestment,
      showWarning: this.state.showWarning,
      next: () => this.next(),
      previous: () => this.previous(),
      handleChange: () => this.handleChange(),
    };
  }

  private handleChange() {
    let investment = new Investment(this.props.investment!);
    investment.termsAndConditions = !investment.termsAndConditions;

    this.props.setInvestmentData(investment);
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
    openModal: (component: JSX.Element): OpenModal => (
      dispatch(openModal(component))
    ),
    closeModal: (): CloseModal => (
      dispatch(closeModal())
    ),
    setInvestmentData: (investment: Investment): SetInvestmentDataAction => (
      dispatch(setInvestmentData(investment))
    ),
  });

const mapStateToProps: (state: RootState) => StateProps = (state: RootState):
  StateProps => ({
    project: state.getProject.project || undefined,
    activeProfile: state.getUser.activeProfile,
    investment: state.setInvestmentData.investment,
  });

export default connect(mapStateToProps, mapDispatchToProps)(InvestmentFunnelContainer);



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/InvestmentFunnel.container.tsx